require('./app.jsx');

let parallax = require('./dynamic-home/parallax');

$('document').ready(function() {
	parallax.init();
});
